/* eslint-disable max-lines-per-function, max-params, max-lines */
import { api } from "jiffy-api";
import { EventBus, Events, store } from "jiffy-store";

import { track } from "jiffy-analytics";

import initCreateCartModal from "components/jiffy/saved-carts-create-modal/saved-carts-create-modal";
import initNamingBenefitsModal from "components/jiffy/naming-benefits-modal/naming-benefits-modal";
import { changeCartName } from "components/jiffy/masthead-cart/masthead-cart";

import "./product-saved-carts-selector.scss";
import EditIcon from "assets/icons/edit.svg?vanilla";
import CheckIcon from "assets/icons/check.svg?vanilla";
import CrossIcon from "assets/icons/cross.svg?vanilla";

const SELECTORS = {
  ROOT: ".js-qty-form-saved-carts",
  WRAPPER: ".js-qty-form-saved-carts-wrapper",
  LIST: ".js-qty-form-saved-carts-list",
  ITEM: ".js-qty-form-saved-carts-item",
  OPTION: ".js-qty-form-saved-cart-option",
  NAME: ".js-qty-form-saved-carts-name",
  NUMBER_INPUT: ".js-qty-form-saved-carts-number",
  SELECT: ".js-qty-form-saved-carts-select",
  INPUT: ".js-qty-form-saved-carts-input",
  ARROW: ".js-qty-saved-cart-chevron",
  BACKDROP: ".js-qty-saved-carts-backdrop",
  POPUP_CLOSE: ".js-saved-carts-close",
  CREATE_CART_BTN: ".js-qty-create-cart",
  SPINNER: ".js-qty-form-saved-carts-spinner",
  QUANTITY: ".js-qty-form-saved-carts-qty",
  AMOUNT: ".js-qty-form-saved-cart-amount",
  BADGE: ".js-qty-saved-carts-badge",
  WRAPPER_SPINNER: ".js-qty-form-saved-carts-wrapper-spinner",
  LIST_SPINNER: ".js-qty-form-saved-carts-list-spinner",
  SPINNER_TEXT: ".js-qty-form-saved-carts-spinner-text",
  EDIT: ".js-qty-form-saved-cart-edit",
  NAME_LABEL: ".js-qty-form-saved-cart-name",
  NAME_INPUT: ".js-qty-form-saved-cart-input",
  APPROVE: ".js-qty-form-saved-cart-approve",
  CANCEL: ".js-qty-form-saved-cart-cancel",
  QUANTITY_FORM: ".js-product-details-quantity-form",
  SAVED_CARTS: ".js-product-grid-saved-cart"
};

const $getQuantityForm = () => document.querySelector(SELECTORS.QUANTITY_FORM);
const $getSavedCartSelectors = () => document.querySelectorAll(SELECTORS.SAVED_CARTS);

const LOADING_MODE = {
  RENAME: "Renaming Cart",
  SWITCH: "Switching Cart"
};

class SavedCartsSelector {
  isOpen = false;

  showCreateModal = false;

  constructor(root, carts, active, showActiveBadge) {
    const { currencySign } = root.dataset;
    this.carts = carts.map(cart => ({ ...cart }));
    this.active = active;
    this.wrapper = root.querySelector(SELECTORS.WRAPPER);
    this.list = root.querySelector(SELECTORS.LIST);
    this.name = root.querySelector(SELECTORS.NAME);
    this.input = root.querySelector(SELECTORS.INPUT);
    this.numberInput = root.querySelector(SELECTORS.NUMBER_INPUT);
    this.select = root.querySelector(SELECTORS.SELECT);
    this.arrow = root.querySelector(SELECTORS.ARROW);
    this.backdrop = root.querySelector(SELECTORS.BACKDROP);
    this.popupClose = root.querySelector(SELECTORS.POPUP_CLOSE);
    this.spinner = root.querySelector(SELECTORS.SPINNER);
    this.createCartBtn = document.querySelector(SELECTORS.CREATE_CART_BTN);
    this.wrapperSpinner = root.querySelector(SELECTORS.WRAPPER_SPINNER);
    this.listSpinner = root.querySelector(SELECTORS.LIST_SPINNER);
    this.spinnerText = root.querySelector(SELECTORS.SPINNER_TEXT);
    this.showActiveBadge = showActiveBadge;
    this.currencySign = currencySign;
    this.isNameEdit = false;

    this.render();
    this.initListeners();
    initCreateCartModal(SELECTORS.CREATE_CART_BTN, root, null, true);
    initNamingBenefitsModal(this.wrapper);
  }

  get activeNode() {
    return this.list.querySelector(`.js-qty-form-saved-carts-item[data-active="true"]`);
  }

  getNodeByNumber = number =>
    this.list.querySelector(`.js-qty-form-saved-carts-item[data-number="${number}"]`);

  getCartByNumber = number => this.carts.find(cart => cart.number === number);

  getItem = (cart, active) => {
    const element = document.createElement("template");
    const template = `
    <div
      class="product-saved-carts-selector__saved-carts-item js-qty-form-saved-carts-item"
      data-number="${cart.number}" data-active="${active}"
      role="button"
      tabindex="0"
    >
      <div class="product-saved-carts-selector__saved-carts-item-row">
        <div class="product-saved-carts-selector__saved-carts-option js-qty-form-saved-cart-option ${
          active ? "product-saved-carts-selector__saved-carts-option--active" : ""
        }"
        data-number="${cart.number}"
        ></div>
        <div class="product-saved-carts-selector__cart-name js-qty-form-saved-cart-name">
          ${cart.cart_name}
        </div>
        <input
          type="text"
          class="product-saved-carts-selector__name-input js-qty-form-saved-cart-input hidden"
          maxlength="50"
          value="${cart.cart_name}"
        />
        <button type="button" class="product-saved-carts-selector__edit js-qty-form-saved-cart-edit">
          ${EditIcon({ className: "icon icon--svg icon--edit" })}
        </button>
        <button type="button" class="product-saved-carts-selector__edit-button product-saved-carts-selector__edit-button--approve js-qty-form-saved-cart-approve hidden">
          ${CheckIcon({ className: "icon icon--svg icon--check" })}
        </button>
        <button type="button" class="product-saved-carts-selector__edit-button js-qty-form-saved-cart-cancel hidden">
          ${CrossIcon({ className: "icon icon--svg icon--cross" })}
        </button>
        <div class="product-saved-carts-selector__badge js-qty-saved-carts-badge ${
          active && this.showActiveBadge ? "" : "hidden"
        }">Active Cart</div>
      </div>
      <div class="product-saved-carts-selector__saved-carts-item-row">
        <div><span class="js-qty-form-saved-carts-qty">${cart.items}</span> Items</div>
        <div class="product-saved-carts-selector__saved-carts-amount">
          ${this.currencySign}
          <span class="js-qty-form-saved-cart-amount">${cart.amount}</span>
        </div>
      </div>
    </div>
    `;
    element.innerHTML = template.trim();
    const node = element.content.firstChild;
    const editButton = node.querySelector(SELECTORS.EDIT);
    const cancelButton = node.querySelector(SELECTORS.CANCEL);
    const approveButton = node.querySelector(SELECTORS.APPROVE);
    const nameInput = node.querySelector(SELECTORS.NAME_INPUT);
    editButton.addEventListener("click", event => this.enableEdit(event, node));
    cancelButton.addEventListener("click", e => {
      this.hideEdits();
      e.stopPropagation();
    });

    node.addEventListener("click", () => this.onSwitch(node, cart.number));
    node.addEventListener("keydown", e => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        if (document.activeElement.tagName === "INPUT") return;
        e.preventDefault();
        this.input.focus();
        this.onSwitch(node, cart.number);
      }
    });

    approveButton.addEventListener("click", event => this.onChangeName(event, node, cart.number));
    nameInput.addEventListener(
      "keydown",
      event => {
        if (event.key === "Enter") {
          this.onChangeName(event, node, cart.number);
        }
      },
      true
    );

    nameInput.addEventListener("input", () => {
      this.toggleInputValidity(nameInput, false);
    });

    nameInput.addEventListener("click", e => {
      e.stopPropagation();
    });

    return node;
  };

  // eslint-disable-next-line class-methods-use-this
  setActiveStatus(node, isActive) {
    node.setAttribute("data-active", isActive.toString());
    const option = node.querySelector(SELECTORS.OPTION);
    const badge = node.querySelector(SELECTORS.BADGE);
    option.classList.toggle("product-saved-carts-selector__saved-carts-option--active", isActive);
    badge.classList.toggle("hidden", !isActive);
  }

  switchNode = (newActiveNode, number) => {
    this.setActiveStatus(this.activeNode, false);
    this.setActiveStatus(newActiveNode, true);
    this.active = this.carts.find(cart => cart.number === number);
    this.name.textContent = this.active.cart_name;
    this.numberInput.value = this.active.number;
  };

  updateCartName = (cartNumber, newName) => {
    const currentCart = this.getCartByNumber(cartNumber);

    if (currentCart.cart_name === newName) {
      return null;
    }

    const currentCartNode = this.getNodeByNumber(cartNumber);
    const nameInput = currentCartNode.querySelector(SELECTORS.NAME_INPUT);
    const nameLabel = currentCartNode.querySelector(SELECTORS.NAME_LABEL);
    currentCart.cart_name = newName;
    nameInput.setAttribute("value", newName);
    nameLabel.textContent = newName;
    if (this.active.number === cartNumber) {
      this.name.textContent = newName;
      this.active.cart_name = newName;
    }

    return currentCart;
  };

  onChangeName = async (event, node, cartNumber) => {
    event.preventDefault();
    event.stopPropagation();

    const nameInput = node.querySelector(SELECTORS.NAME_INPUT);

    if (!nameInput.value) {
      this.toggleInputValidity(nameInput, true);
      return;
    }

    const newCart = this.updateCartName(cartNumber, nameInput.value);
    this.hideEdits();
    if (!newCart) return;
    this.toggleLoading(true, LOADING_MODE.RENAME);
    await api.jiffyshirts.savedCart.update({ id: cartNumber }, { saved_carts: newCart });
    this.toggleLoading(false);

    store.pdp.change({
      activeCart: this.active,
      carts: this.carts
    });

    EventBus.publish(Events.SAVED_CART_CHANGED, this, {
      cartNumber,
      newName: newCart.cart_name
    });

    changeCartName(cartNumber, newCart.cart_name);

    track("saved_carts_inline_edit_saved");
  };

  onCreate = cartData => {
    const newCart = { ...cartData };
    const isNewCartExists = this.carts.some(obj => newCart.number === obj.number);
    if (isNewCartExists) return;

    this.carts.unshift(newCart);
    const newNode = this.getItem(newCart, false);
    this.list.prepend(newNode);
    this.switchNode(newNode, newCart.number);
    store.pdp.change({
      activeCart: this.active,
      savedCarts: this.carts
    });
  };

  hideEdits = () => {
    const nameLabels = this.list.querySelectorAll(SELECTORS.NAME_LABEL);
    const nameInputs = this.list.querySelectorAll(SELECTORS.NAME_INPUT);
    const editButtons = this.list.querySelectorAll(SELECTORS.EDIT);
    const approveButtons = this.list.querySelectorAll(SELECTORS.APPROVE);
    const cancelButtons = this.list.querySelectorAll(SELECTORS.CANCEL);
    const items = this.list.querySelectorAll(SELECTORS.ITEM);

    if (this.isNameEdit) {
      track("saved_carts_inline_edit_dismissed");
    }

    this.isNameEdit = false;

    const showElems = el => el.classList.remove("hidden");
    const hideElems = el => el.classList.add("hidden");
    const removeEditClass = el => el.classList.remove("inline-edit");

    this.resetNameInputs();
    nameLabels.forEach(showElems);
    nameInputs.forEach(hideElems);
    editButtons.forEach(showElems);
    approveButtons.forEach(hideElems);
    cancelButtons.forEach(hideElems);
    items.forEach(removeEditClass);
  };

  enableEdit = (event, node) => {
    this.hideEdits();
    this.isNameEdit = true;
    const nameLabel = node.querySelector(SELECTORS.NAME_LABEL);
    const nameInput = node.querySelector(SELECTORS.NAME_INPUT);
    const editButton = node.querySelector(SELECTORS.EDIT);
    const approveButton = node.querySelector(SELECTORS.APPROVE);
    const cancelButton = node.querySelector(SELECTORS.CANCEL);
    event.preventDefault();
    event.stopPropagation();
    node.classList.add("inline-edit");
    nameLabel.classList.add("hidden");
    editButton.classList.add("hidden");
    nameInput.classList.remove("hidden");
    approveButton.classList.remove("hidden");
    cancelButton.classList.remove("hidden");

    track("saved_carts_inline_edit_started", { page: "product_page" });
  };

  onSwitch = async (node, number) => {
    if (this.active.number === number) {
      return;
    }
    this.hideEdits();
    this.toggleLoading(true, LOADING_MODE.SWITCH);
    await api.account.savedCarts.switch({ number });
    this.switchNode(node, number);
    this.toggleLoading(false);

    store.pdp.change({
      activeCart: this.active
    });

    track("saved_carts_default_changed", { trigger: "product_page" });

    EventBus.publish(Events.SAVED_CART_SELECTED, this, {
      number,
      name: this.active.cart_name,
      items: this.active.items
    });
    this.toggleSelector(false);
  };

  toggleLoading = (isLoading, loadingText) => {
    this.spinnerText.textContent = loadingText;
    this.listSpinner.classList.toggle("hidden", !isLoading);
  };

  toggleSelector = isOpen => {
    this.isOpen = isOpen;
    this.input.ariaExpanded = isOpen;
    this.select.classList.toggle("hidden", !this.isOpen);
    this.backdrop.classList.toggle("hidden", !this.isOpen);
    this.arrow.classList.toggle("product-saved-carts-selector__chevron--open", this.isOpen);
    document.documentElement.classList.toggle("locked-mobile", this.isOpen);

    if (isOpen) {
      track("saved_carts_dropdown_add_to_cart_selector_opened", { page: "product_page" });
    } else {
      this.hideEdits();
    }
  };

  // eslint-disable-next-line class-methods-use-this
  toggleInputValidity = (input, isInvalid) => {
    input.classList.toggle("product-saved-carts-selector__name-input--invalid", isInvalid);
  };

  resetNameInputs() {
    const $items = this.list.querySelectorAll(SELECTORS.ITEM);

    $items.forEach($item => {
      const { number } = $item.dataset;
      const cart = this.getCartByNumber(number);

      if (!cart) return;

      const { cart_name: cartName } = cart;
      const $nameInput = $item.querySelector(SELECTORS.NAME_INPUT);

      this.toggleInputValidity($nameInput, false);
      $nameInput.value = cartName;
    });
  }

  initListeners() {
    this.input.addEventListener("click", () => {
      this.toggleSelector(!this.isOpen);
    });

    this.popupClose.addEventListener("click", () => {
      this.toggleSelector(false);
    });

    this.createCartBtn.addEventListener("click", () => {
      this.toggleSelector(false);
    });

    // a11y
    this.input.addEventListener("keydown", e => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        this.toggleSelector(!this.isOpen);
      }
      if (e.keyCode === 27) {
        this.toggleSelector(false);
      }
    });

    this.select.addEventListener("keydown", e => {
      if (e.keyCode === 27) {
        this.input.focus();
        this.toggleSelector(false);
      }
    });

    /**
     * Listen for a click outside of the box area to close it.
     * When the click started inside the box area and ended outside, we should avoid this case.
     * For that is used "mousedown" event instead of "click".
     */
    document.addEventListener("mousedown", event => {
      if (!this.isOpen) {
        return;
      }

      const clickInside = event.composedPath().includes(this.wrapper);

      if (!clickInside) {
        this.toggleSelector(false);
      }
    });

    EventBus.on(Events.SAVED_CART_SELECTED, (_, { number }) => {
      if (this.active.number === number && this.showActiveBadge) {
        return;
      }

      this.showActiveBadge = true;
      const currentNode = this.getNodeByNumber(number);
      this.switchNode(currentNode, number);
    });

    EventBus.on(Events.SAVED_CART_CREATED, async (_, newCart) => this.onCreate(newCart));
    EventBus.on(Events.SAVED_CART_CHANGED, (_, { cartNumber, newName }) =>
      this.updateCartName(cartNumber, newName)
    );

    EventBus.on(Events.ITEMS_ADDED_TO_CART, ({ target }) => {
      this.active.items += target.quantity;
      this.active.amount = target.cart_total;
      const currentCartNode = this.activeNode;
      const qtyField = currentCartNode.querySelector(SELECTORS.QUANTITY);
      const amountField = currentCartNode.querySelector(SELECTORS.AMOUNT);
      qtyField.textContent = this.active.items;
      amountField.textContent = Number(this.active.amount).toFixed(2);

      this.carts = this.carts.map(cart =>
        cart.number === this.active.number ? this.active : cart
      );

      const savedActiveCart = store.get(state => state.pdp.activeCart);
      if (savedActiveCart.items === this.active.items) {
        return;
      }

      store.pdp.change({
        savedCarts: this.carts,
        activeCart: this.active
      });
    });
  }

  render() {
    const items = this.carts.map(cart =>
      this.getItem(cart, this.active && this.active.number === cart.number)
    );

    this.list.replaceChildren(...items);
    this.name.textContent = this.active.cart_name;
    this.numberInput.value = this.active.number;
    this.wrapper.classList.remove("hidden");
    this.wrapperSpinner.classList.add("hidden");
  }
}

const initCarts = async root => {
  const cachedValues = store.get(state => ({
    carts: state.pdp.savedCarts,
    active: state.pdp.activeCart,
    showActiveBadge: state.pdp.showActiveBadge
  }));

  if (cachedValues.carts) {
    return new SavedCartsSelector(
      root,
      cachedValues.carts,
      cachedValues.active,
      cachedValues.showActiveBadge
    );
  }

  const response = await Promise.all([
    api.jiffyshirts.savedCart.list(),
    api.jiffyshirts.savedCart.current()
  ]);

  if (response[0].error) {
    root.classList.add("hidden");
    return null;
  }

  const [{ carts }, active] = response;
  let activeCart = carts.find(cart => cart.number === active.number);
  let showActiveBadge = true;

  if (!activeCart) {
    [activeCart] = carts;
    showActiveBadge = false;
  }

  store.pdp.change({
    savedCarts: carts,
    activeCart,
    showActiveBadge
  });

  return new SavedCartsSelector(root, carts, activeCart, showActiveBadge);
};

const init = $parentElement => {
  const $root = $parentElement?.querySelector(SELECTORS.ROOT);
  $root && initCarts($root);
};

const initAllSelectors = () => {
  $getSavedCartSelectors().forEach($select => {
    init($select);
    $select.classList.remove("hidden");
  });
};

export default (multiSelect = false) => {
  const $form = $getQuantityForm();
  if (!multiSelect) {
    init($form);
  } else {
    initAllSelectors();
  }

  let loaded = false;
  store.pdp.changed((_, { data }) => {
    if (!data.productGridLoaded || loaded || !window.inventory) return;
    loaded = true;

    const savedCarts = store.get(state => state.pdp.savedCarts);
    if (!savedCarts) {
      return;
    }

    initAllSelectors();
  });
};
